/**
 * Mapa de rotas — fonte única da navegação.
 *
 * Os caminhos aqui são RELATIVOS à base da aplicação, hoje a raiz. Durante o
 * porte a base foi `/v2`, para a V1 continuar operável na mesma branch; desde
 * o corte (21/09/2026) tanto os endereços da V1 quanto os `/v2/...` que alguém
 * tenha guardado viram redirecionamento. Nenhum componente escreve caminho
 * absoluto: quem navega usa `appPath`.
 */
export const APP_BASE = "";

export interface NavEntry {
  /** Caminho relativo à base; vazio é o índice. */
  path: string;
  label: string;
  /** Entradas do pill-nav superior, na ordem do protótipo. */
  primary: boolean;
}

export const NAV: NavEntry[] = [
  { path: "", label: "Início", primary: true },
  { path: "leads", label: "Leads", primary: true },
  { path: "mensagens", label: "Mensagens", primary: true },
  { path: "funis", label: "Funis", primary: true },
  { path: "analise", label: "Análise", primary: true },
  { path: "tarefas", label: "Tarefas", primary: true },
  { path: "notificacoes", label: "Notificações", primary: true },
  { path: "clientes", label: "Clientes", primary: false },
  { path: "empresas", label: "Empresas", primary: false },
  { path: "lixeira", label: "Lixeira", primary: false },
  { path: "configuracoes", label: "Configurações", primary: false },
];

export const PRIMARY_NAV = NAV.filter((entry) => entry.primary);

/** Endereços da V1 que passam a redirecionar para a superfície equivalente. */
export const V1_REDIRECTS: Array<{ from: string; to: string }> = [
  { from: "/overview", to: "" },
  { from: "/pipeline", to: "funis" },
  { from: "/funnels", to: "funis" },
  { from: "/tasks", to: "tarefas" },
  { from: "/inbox", to: "mensagens" },
  { from: "/companies", to: "empresas" },
  // Automação não tem tela própria: o protótipo fundiu o processo ao funil.
  { from: "/automation", to: "funis" },
  { from: "/settings", to: "configuracoes" },
];

/** Monta um caminho absoluto a partir de um caminho relativo do mapa. */
export function appPath(relative = ""): string {
  const clean = relative.replace(/^\/+/, "");
  return clean ? `${APP_BASE}/${clean}` : APP_BASE || "/";
}

/** Prefixo antigo do porte; endereços guardados continuam abrindo. */
export const PORT_BASE = "/v2";
